module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400.woff?347639ec49f4b2884a9657afded83ace";